import http from "@/utils/request"

export default {
	region: {
		list: async function (data = {}) {
			return await http.get("region/list", data);
		},
		add: async function (data = {}) {
			return await http.post("region/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("region/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("region/del", data);
		},
		option: async function (data = {}) {
			return await http.get("region/option", data);
		},
	},
	mcc: {
		list: async function (data = {}) {
			return await http.get("mcc/list", data);
		},
		info: async function (data = {}) {
			return await http.get("mcc/info", data);
		},
		add: async function (data = {}) {
			return await http.post("mcc/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("mcc/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("mcc/del", data);
		},
		option: async function (data = {}) {
			return await http.get("mcc/option", data);
		},
	},
	bank: {
		list: async function (data = {}) {
			return await http.get("bank/list", data);
		},
		info: async function (data = {}) {
			return await http.get("bank/info", data);
		},
		add: async function (data = {}) {
			return await http.post("bank/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("bank/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("bank/del", data);
		},
		option: async function (data = {}) {
			return await http.get("bank/option", data);
		},
	},
	branch: {
		list: async function (data = {}) {
			return await http.get("branch/list", data);
		},
		info: async function (data = {}) {
			return await http.get("branch/info", data);
		},
		add: async function (data = {}) {
			return await http.post("branch/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("branch/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("branch/del", data);
		},
		option: async function (data = {}) {
			return await http.get("branch/option", data);
		},
	},
}
